import { combineReducers } from 'redux';
import auth from './auth';
import settings from './settings';
import gallery from './gallery';
import list from './list';
import core from './core';

export default combineReducers({
  auth,
  settings,
  gallery,
  list,
  core
});
